import { Button } from '@framework/ui/atoms/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { Trans, useTranslation } from 'react-i18next';
type ExternalLinkProps = {
  href: string;
  children?: React.ReactNode;
};
const ExternalLink: React.FC<ExternalLinkProps> = ({ href, children }: ExternalLinkProps) => {
  return (
    <a href={href} target="_blank" rel="noreferrer" className="text-blue-700 underline hover:text-blue-800">
      {children} <FontAwesomeIcon icon={faExternalLinkAlt} />
    </a>
  );
};

type Props = {
  onAgree(): void;
};

export const EulaAgreementFooter: React.FC<Props> = ({ onAgree }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="pointer-events-auto mx-auto flex w-4/5 rounded-t-xl bg-brand-light p-4">
      <div className="flex grow flex-col">
        <div className="py-2">
          <Trans
            i18nKey="auth.eula.consent"
            components={{
              termsLink: <ExternalLink href="https://levii.co.jp/legal/terms-of-service/" />,
              privacyLink: <ExternalLink href="https://levii.co.jp/legal/privacy-policy/" />,
            }}
          />
          <br />
          {t('auth.eula.helpNote')}
        </div>
      </div>
      <div className="my-auto px-8">
        <Button color="brand" onClick={onAgree} className="w-56">
          {t('auth.eula.agreeButton')}
        </Button>
      </div>
    </div>
  );
};
